import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Label.module.css'

export function Label ({ text }) {
  const { t } = useTranslation()
  return <span className={styles.label}>{t(text)}</span>
}
